/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=53e81990&scoped=true"
import script from "./MessageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=53e81990&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e81990",
  null
  
)

export default component.exports